import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	provider: '',
	token: '',
	isError: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case types.SAVE_PROVIDER_TOKEN:
				draft.provider = action.payload.provider;
				draft.token = action.payload.token;
				draft.isError = false;
				return;
			case types.DELETE_PROVIDER_TOKEN:
				draft.provider = '';
				draft.token = '';
				draft.isError = false;
				return;
			case types.NOT_RELATED_ACCOUNT_ERROR:
				draft.isError = true;
				return;
			default:
				return state;
		}
	});
